import { Link } from 'react-router-dom';
import { Button } from '../components/button/Button';
import { Card } from '../components/card/Card';
import { PageShell } from '../components/PageShell';
import { RulesDropdown } from '../components/rules/RulesDropdown';
import { useLanguage } from '../api/useLanguage';
import styles from './HomePage.module.css';

export default function HomePage() {
  const [lang, setLang] = useLanguage();

  return (
    <PageShell>
      <Card>
        <div className="col">
          <Link to="/join">
            <Button>Join Game</Button>
          </Link>
          <Link to="/create">
            <Button>Create Game</Button>
          </Link>
        </div>
      </Card>
      <RulesDropdown lang={lang} onLangChange={setLang} />
      <Link to="/admin" className={styles.adminLink}>admin</Link>
    </PageShell>
  );
}
